export const paymentMethods = {
    CC: 'CC',
    WIRE: 'WIRE',
    CHECK: 'CHECK',
}

export const EXPIRATION_DAYS_FOR_SHOWING_WARNING = 15



// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/companyInfoPanel/constants.js